import { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ Import this
import './Admin.css';

function Admin() {
  const navigate = useNavigate(); // ✅ Hook to navigate programmatically

  const validUsername = "admin";
  const validPassword = "password123";

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === validUsername && password === validPassword) {
      setIsSuccess(true);
      setMessage("✅ Login successful!");

      // Redirect after short delay (1 second)
      setTimeout(() => {
        navigate('/dashboard');
      }, 1000);
    } else {
      setIsSuccess(false);
      setMessage("❌ Invalid username or password.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="title">Admin Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="input-field"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-field"
            />
          </div>
          <button type="submit" className="login-button">Login</button>
        </form>

        {message && (
          <p className={`message ${isSuccess ? 'success' : 'error'}`}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

export default Admin;
